<div class="mt-block">
  <div class="mt-wrapper">
    <fou-container :id="$vId(this, 'channels')" cols="12" background padded>
      <template #header>
        <h3 class="mt-h3">{{$t('pages.channels.header')}}</h3>
      </template>
      <template #content>
        <div v-if="spinner" :class="$style.pageMargin">
          <animation-processing fill="new-blue" :class="$style.pageSpinner"></animation-processing>
          <span class="mt-serif mt-serif--size3"> {{$t('pages.channels.spinner')}} </span>
        </div>
        <div v-if="!spinner && !contractStatus" :class="$style.releasedChannelsWarning">
          <img :src="getSrc" />
          <p v-html="$t('pages.channels.ufdaContractDesc1')"></p>
        </div>
        <div v-if="!spinner && contractStatus" :class="$style.releasedChannelsOk">
          <ok-icon :class="[$style.ok]" />
          <div :class="$style.channelsImageWrapper">
            <p :class="$style.descText">{{getDescriptionHeadText}}</p>
            <ul :class="[$style.ulItem]">
              <li :class="[$style.listItem]" v-for="item, idx in channelSrc" :key="idx">
                <img :class="[$style.picture]" :id="$vId(this, 'icon')" :src="item.src" />
              </li>
            </ul>
          </div>
        </div>
      </template>
    </fou-container>
  </div>
</div>
